import React from "react";
import { connect } from "react-redux";
import { green, pink } from '@material-ui/core/colors';
import Popover from '@material-ui/core/Popover';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Person from "@material-ui/icons/Person";
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemButton from '@material-ui/core/ListItemButton';
// import ListItemText from '@material-ui/core/ListItemText';
// import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Axios from 'axios';
import { API_CONFIG } from "../../config/config.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from '@material-ui/core/Button';
// core components
import { logout } from '../../actions/auth';
import { changeCity } from '../../actions/city';
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import { User } from "../../User";
import ResetPasswordDialog from '../../../src/views/Authentication/resetPassword/index.js';

// const UserBoxButton = styled(Button)(
//   ({ theme }) => `
//     padding: ${theme.spacing(0, 1)};
//     color: ${theme.colors.alpha.trueWhite[50]};
//     background-color: ${theme.colors.alpha.white[10]};
//     height: 48px;
//     border-radius: ${theme.general.borderRadiusLg};

//     .MuiSvgIcon-root {
//       transition: ${theme.transitions.create(['color'])};
//       font-size: ${theme.typography.pxToRem(24)};
//       color: ${theme.colors.alpha.trueWhite[50]};
//     }

//     .MuiAvatar-root {
//       border-radius: ${theme.general.borderRadiusLg};
//       width: 34px;
//       height: 34px;
//     }

//     &.Mui-active,
//     &:hover {
//       background-color: ${alpha(theme.colors.alpha.white[30], 0.2)};

//       .MuiSvgIcon-root {
//         color: ${theme.colors.alpha.trueWhite[100]};
//       }
//     }

//     .MuiButton-label {
//       justify-content: flex-start;
//     }
// `
// );

class HeaderLinks extends React.Component {
  state = {
    cityWithPins: [],
    city: '',
    pincodes: [],
    open: false,
    anchorEl: null,
    openResetPasswordDialog:false,
    defaultHydCity: '',
    hydData: '',
    indiaflag:true
  };
  popoverRef = React.createRef();
  componentDidMount() {

      const token = sessionStorage.getItem('plugoAuthKey');
      const userId = sessionStorage.getItem('plugoUserId');
      console.log('token', token);
      console.log('userId', userId);
    // if(process.env.REACT_APP_ACTIVE_REGION === "europe" )
    // {
    //   Axios.get(`${API_CONFIG.HOST}/get/cities/${userId}`,  {
    //     headers: {
    //         "Authorization": `Bearer ${token}`,
    //     }
    // })
    //   .then(res => {
    //     console.log("get city res", res.data);
    //     if(res.data.length === 0 ){
    //       this.setState({
    //         cityWithPins: []
    //       });
    //     }
    //     else{
    //       this.setState({
    //         cityWithPins: res.data.city,
    //         // city: res.data.city[0]
    //         city: 'All'
    //       });
    //       this.props.changeCity(res.data.city[0]);
    //     }
    //   })
    //   .catch((error)=>{
    //     console.log("get city error", error);
    //   })
    // }
    // else
    // {
      
    //   Axios.get(`${API_CONFIG.HOST}/store-report/stores/cities/${userId}`,  {
    //       headers: {
    //           "Authorization": `Bearer ${token}`,
    //           "X-USER-ID" : userId
    //       }
    //   }
    //   )
    //     .then(res => {
    //       if(res.data.length === 0 ){
    //         this.setState({
    //           cityWithPins: []
    //         });
    //       }
    //       else{
    //         this.setState({
    //           cityWithPins: res.data,
    //           city: res.data[0].City
    //         });
    //         this.props.changeCity(res.data[0].City, res.data[0].Pincodes);
    //       }
    //     });
    // }
    
  }
  handleChange = event => {
    this.setState({
      city: event.target.value
    });
    let selectedCity = this.state.cityWithPins.find(selectCity => {
      return selectCity === event.target.value
    });
    console.log(selectedCity);
    this.props.changeCity(event.target.value, selectedCity.Pincodes);


  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl:  event.currentTarget });
  };
  resetPasswordClose = () => {
    this.setState({ openResetPasswordDialog: false });
  };

  resetPasswordOpen = async(event) => {
    let token = sessionStorage.getItem('plugoAuthKey');
  try{
  await Axios.post(`${API_CONFIG.HOST}/user/forgot-password`, {
    userMail: null
  },{
    headers: {
      'Content-Type': 'application/json',
      "Authorization": `Bearer ${token}`,
    }
  },).then(res=>{
    this.setState({ loading: false })
    
  })
} catch(err){
console.log({err})
}
    this.handleMenuClose()
    this.setState({ openResetPasswordDialog: true });
  };



  render() {
    const { classes } = this.props;
    const { open } = this.state;
    const { anchorEl } = this.state;
    const openMenu = Boolean(anchorEl);
    let filterCity = [];
    if(!User.isSuperAdmin()){
      filterCity = this.state.cityWithPins.filter(e => e.city !== "All")
    }else{
      filterCity = this.state.cityWithPins
      // filterCity.push("All")
    }
  //  filterCity.unshift('All')
  //  filterCity = ["All", ...filterCity]
    let menuCities = filterCity.map(menuCity => (

      <MenuItem key={menuCity} value={menuCity}>{menuCity}</MenuItem>
    ));
    console.log("userr ", User.isSuperAdmin(), this.state.cityWithPins)
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginBottom: "10px",
          }}
        >
          {/* {this.state.indiaflag ? ( */}
          {/* <form className={classes.form} autoComplete="on">
            <FormControl style={{ marginRight: "35px", minWidth: 120 }}>
              <InputLabel htmlFor="demo-controlled-open-select">
                City
              </InputLabel>
              <Select 
                open={this.state.open}
                onClose={this.handleClose}
                onOpen={this.handleOpen}
                value={this.state.city}
                onChange={this.handleChange}
                inputProps={{
                  name: "city",
                  id: "demo-controlled-open-select",
                }}
              >
                {menuCities}
              </Select>
            </FormControl>
          </form> */}
          <div>
            <Button
              fullWidth
              color="secondary"
              ref={this.popoverRef}
              onClick={this.handleMenuOpen}
            >
              <Avatar>
                <Person fontSize="large" />
              </Avatar>
            </Button>
            <Popover
              disableScrollLock
              anchorEl={anchorEl}
              onClose={this.handleMenuClose}
              open={openMenu}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "left",
                  rowGap: 1,
                  p: 1.5,
                }}
              >
                {/* <Button onClick={() => this.resetPasswordOpen()}>
                  Reset Password
                </Button> */}

                <Button
                  onClick={() => {
                    this.props.logout();
                  }}
                >
                  Logout
                </Button>
              </Box>
            </Popover>
            {/* <Button
              onClick={() => this.props.logout()}
              variant="contained"
              color="inherit"
              className={classes.button}>
              Logout
         </Button> */}
          </div>
        </div>
        {this.state.openResetPasswordDialog &&
          <ResetPasswordDialog 
          open={this.state.openResetPasswordDialog} 
          handleOpen={this.resetPasswordOpen} 
          handleClose={this.resetPasswordClose}/>}
      </div>
    );
  }
}

export default connect(null, { logout, changeCity }, null, { pure: false })(withStyles(headerLinksStyle)(HeaderLinks))